import { API_ROUTES_FOR_AXIOS } from '../constants/ApiRoutes';
import { axiosInstance } from '../constants/axiosInstance';
import { ApiResponse } from 'src/types/commonResponseTypes';
import {
  ActiveUserPingPayload,
  UserWithoutTokens,
} from 'src/types/activeUsers';
import { handleError } from 'src/utils/commonErrorUtils';

export const pollActiveUser = async (
  payload: ActiveUserPingPayload,
): Promise<ApiResponse<string>> => {
  try {
    const apiUrl = API_ROUTES_FOR_AXIOS['pollActiveUser']();
    const { data } = await axiosInstance.post(apiUrl, payload);

    return data;
  } catch (error) {
    return handleError(error);
  }
};

export const getActiveUsers = async (): Promise<
  ApiResponse<UserWithoutTokens[]>
> => {
  try {
    const apiUrl = API_ROUTES_FOR_AXIOS['getActiveUsers']();
    const { data } = await axiosInstance.get(apiUrl);

    return data;
  } catch (error) {
    return handleError(error);
  }
};
